// extracted by mini-css-extract-plugin
module.exports = {"heading":"login_heading__1ymAy","sub-heading":"login_sub-heading__2F_2h","terms-condition":"login_terms-condition__3xM2R","inp-below-text":"login_inp-below-text__26eIP"};